import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type WhatsappLiveChatModuleSpecsFragment } from '../../../../api/fragments/WhatsappLiveChatModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';
import { useWhatsappLivechatSettingsDrawer } from './WhatsappLiveChatSettingsDrawer';

export type WhatsappLiveChatSettingsEmptyListProps = {
    module: WhatsappLiveChatModuleSpecsFragment;
};

const WhatsappLiveChatSettingsEmptyList = ({ module }: WhatsappLiveChatSettingsEmptyListProps) => {
    const { t } = useTranslation(['whatsappLiveChatModuleDetails']);
    const drawer = useWhatsappLivechatSettingsDrawer(module.id);

    return (
        <>
            <NoItemResult
                extra={
                    <Button onClick={drawer.open} type="primary">
                        {t('whatsappLiveChatModuleDetails:emptyList.settings.noData.action')}
                    </Button>
                }
                subTitle={t('whatsappLiveChatModuleDetails:emptyList.settings.noData.message')}
            />
            {drawer.render()}
        </>
    );
};

export default WhatsappLiveChatSettingsEmptyList;
